import { zodResolver } from '@hookform/resolvers/zod';
import { Grid } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import {
  EditableLegalClientSchema,
  IEditableLegalClient,
} from '../../../../../../../Interfaces/IEditLegalClient';
import {
  getEmptyLegalClient,
  ILegalClient,
} from '../../../../../../../Interfaces/ILegalClient';
import { initAddress } from '../../../../../../../Interfaces/ILegalClientAddress';
import { ILegalTransactionRelationship } from '../../../../../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationship';
import { getEmptyChildMember } from '../../../../../../../Interfaces/ILegalTransactionRelationship/Members/IMemberChild';
import {
  getEmptyFamilyRelationship,
  IFamilyRelationship,
} from '../../../../../../../Interfaces/ILegalTransactionRelationship/Relationships/Family/ILegalTransactionFamilyRelationship';
import { getEmptyNaturalPerson } from '../../../../../../../Interfaces/INaturalPerson';
import { EditLegalClient } from '../../../../../../LegalClient/EditLegalClient';
import { useLegalClientStore } from '../../../../generic/legalClientStore';
import { NavRow } from '../../../../generic/NavRow';
import { updateOrCreateRelationship } from '../../../../generic/utilities';
import { isFamilyRelationship } from '../../../../Inherit/utilities';

type CreateChildSlideProps = {
  relationshipId: number;
  relationshipArray: ILegalTransactionRelationship[];
  setRelationshipArray: React.Dispatch<
    React.SetStateAction<ILegalTransactionRelationship[]>
  >;

  handleClose: () => void;
  handleNext: () => void;
  handleBack: () => void;
};

export function CreateChildSlide({
  relationshipId,
  relationshipArray,
  setRelationshipArray,
  handleNext,
  handleBack,
}: CreateChildSlideProps) {
  const [putLegalClient] = useLegalClientStore(state => [state.putLegalClient]);

  const legalClientMethods = useForm<IEditableLegalClient>({
    mode: 'onChange',
    defaultValues: {
      ...getEmptyLegalClient(),
      ...getEmptyNaturalPerson(),
      AddressArray: [initAddress()],
      idLegalClient: 1,
    },
    resolver: zodResolver(EditableLegalClientSchema),
  });

  async function onSubmit() {
    const legalClientValid = await legalClientMethods.trigger();

    if (!legalClientValid) {
      console.error('Legal client form is not valid');
      return;
    }

    const baseRelationship = relationshipArray
      .filter(isFamilyRelationship)
      .find(rel => rel.idRelationship === relationshipId);

    if (!baseRelationship) {
      const newFamilyRelationship = getEmptyFamilyRelationship();
      return;
    }

    const newLegalClient = legalClientMethods.getValues() as ILegalClient;

    const updatedLegalClient = putLegalClient(newLegalClient);

    const updatedFamilyRelationship: IFamilyRelationship = {
      ...baseRelationship,
      Members: [
        ...baseRelationship.Members,
        getEmptyChildMember(
          updatedLegalClient,
          baseRelationship.idRelationship
        ),
      ],
    };

    setRelationshipArray(
      updateOrCreateRelationship(relationshipArray, updatedFamilyRelationship)
    );

    handleNext();
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormProvider {...legalClientMethods}>
          <form id='testator-legal-client-form' noValidate>
            <EditLegalClient disableCompanyLegalClient />
          </form>
        </FormProvider>
      </Grid>

      <Grid item xs={12}>
        <NavRow
          nextButtonText='Speichern'
          backButtonText='Abbrechen'
          handleNext={onSubmit}
          handleBack={handleBack}
        />
      </Grid>
    </Grid>
  );
}
